export type ErrorWithMessage = {
    message: string
}

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
    return (
        typeof error === 'object' &&
        error !== null &&
        'message' in error &&
        typeof (error as Record<string, unknown>).message === 'string'
    )
}

export function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
    if (isErrorWithMessage(maybeError)) {
        const searchString = "\"message\":\"";
        let index = maybeError.message.indexOf(searchString);
        if (index !== -1) {
            let message = maybeError.message.substring(index + searchString.length);
            index = message.indexOf("\"");
            if(index !== -1){
                maybeError.message = message.substring(0,index);
            }
        }
        return maybeError
    }

    try {
        return new Error(JSON.stringify(maybeError))
    } catch {
        // fallback in case there's an error stringifying the maybeError
        // like with circular references for example.
        return new Error(String(maybeError))
    }
}
